import * as React from "react";
import { useNavigate } from "@reach/router";

import api from "kw/api";

export const useActivePolicy = () => {
  const [loading, setLoading] = React.useState(false);
  const [policyId, setPolicyId] = React.useState(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    async function effect() {
      setLoading(true);

      try {
        const response = await api.query(getActivePolicyQuery(), {});
        const policyResponse = response?.activePolicy || {};
        setPolicyId(policyResponse.id);
      } catch (e) {
        navigate("/");
      } finally {
        setLoading(false);
      }
    }
    if (!policyId) {
      effect();
    }
  }, []);
  return { activePolicyId: policyId, loading };
};

export function getActivePolicyQuery() {
  return {
    activePolicy: [
      {},
      {
        id: true,
      },
    ],
  };
}
